/* eslint-disable react/prop-types */
import { useField } from 'formik'
import styled from 'styled-components'

import { Box, Input } from '@redriverpress/system'

import Hint from './Hint'

/** Sign-up 'email has been already used' remote error includes a link to sign-in. Apply some styles to it */
const StyledError = styled(Box)`
  display: inherit;

  a {
    color: ${({ theme }) => theme.colors.black};

    &:hover,
    &:focus {
        color: ${props => props.theme.colors.blue500};
      }
    }
  }
`

function SanitizedText({ sanitize, children, ...props }) {
  if (sanitize) {
    return <StyledError {...props}>{children}</StyledError>
  }

  return (
    <StyledError {...props} dangerouslySetInnerHTML={{ __html: children }} />
  )
}

export default function Field(props) {
  const [field, meta] = useField(props)

  const { touched, error } = meta
  const { hint, hideError, ...rest } = props
  const { mb, mr, width, as, display, sanitizeError, ...fieldProps } = rest

  const Component = as || Input

  let errorMessage = false
  if (touched && error && !hideError) {
    errorMessage = (
      <SanitizedText sanitize={sanitizeError}>{error}</SanitizedText>
    )
  }

  return (
    <Box display={display} width={width} mb={mb} mr={mr}>
      <Component
        error={errorMessage}
        iconRight={hint && <Hint text={hint} />}
        {...field}
        {...fieldProps}
      />
    </Box>
  )
}

Field.defaultProps = {
  width: 1,
  mb: 3,
  mr: null,
  sanitizeError: true,
  hideError: false,
  display: 'inline-block',
}
